export const EDITORIAL_PAGE_RECEIVED = '@ZAPI_EDITORIAL_PAGE_RECEIVED';
export const EDITORIAL_TEASERS_RECEIVED = '@ZAPI_EDITORIAL_TEASERS_RECEIVED';
export const EDITORIAL_SUB_NAVIGATION_RECEIVED = '@ZAPI_EDITORIAL_SUB_NAVIGATION_RECEIVED';
export const EDITORIAL_SEARCH_EXTERNAL_CONTENT_RECEIVED = '@ZAPI_EDITORIAL_SEARCH_EXTERNAL_CONTENT_RECEIVED';
export const EDITORIAL_EXTERNAL_CONTENT_RECEIVED = '@ZAPI_EDITORIAL_EXTERNAL_CONTENT_RECEIVED';
